import axios from 'axios';
import lodash from 'lodash';
import * as previaStudio from '../../services/previaStudio';

const USERKEY = window.location.host.split('.')[0] + '-clic-framework';

const temKey = () => localStorage.getItem(USERKEY) !== null;

let idiomaEmUsoCache;

const adicionaAuthorization = (token) => {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}` 
}

const removeAuthorization = () => {
  delete axios.defaults.headers.common.Authorization;
}

const getUserObj = () => {
  if (temKey()) {
    let userObj = JSON.parse(localStorage.getItem(USERKEY));
    adicionaAuthorization(userObj.token);
    return JSON.parse(localStorage.getItem(USERKEY));
  }
  return temKey() ? JSON.parse(localStorage.getItem(USERKEY)) : ''
}

const getLocalData = (keysToPreserve) => {
  const userObj = getUserObj()

  if (!userObj) { return {} };

  return keysToPreserve.reduce((acc, key) => {
    if (userObj.hasOwnProperty(key)) {
      acc[key] = userObj[key];
    }
    return acc;
  }, {});
};

const setUserObj = (_this, userObj) => {
  if  (userObj && userObj.token) {
    localStorage.setItem(USERKEY, JSON.stringify(userObj));
    adicionaAuthorization(userObj.token);

    const postMessage = {
      type : "userAction",
      params : { 
        action : "login"
      }
    };
    _this.window?.ReactNativeWebView?.postMessage(JSON.stringify(postMessage));
    _this.$router.push({ name: _this.$router.getRoutes().filter(item => item.meta.isHome)[0].name });
    if  (userObj.salvarLogin) {
      addUsuarioHistorico(userObj);
    }
  }
}

const setIdioma = (idioma) => {
  if(temKey()){
    let obj = JSON.parse(localStorage.getItem(USERKEY));
    obj.idioma = idioma;
    localStorage.setItem(USERKEY, JSON.stringify(obj));
    idiomaEmUsoCache = idioma;
  }
}

const getIdioma = () => {
  if  (idiomaEmUsoCache) { return idiomaEmUsoCache };

  if(temKey()){
    let obj = JSON.parse(localStorage.getItem(USERKEY));
    idiomaEmUsoCache = obj.idioma || 'PT';
    return idiomaEmUsoCache;
  } else {
    return 'PT';
  }
}

const getUsuariosHistorico = () => {
  let obj = JSON.parse(localStorage.getItem(USERKEY));
  return (obj && obj.usuariosHistorico) || [];
}

const addUsuarioHistorico = (userToAdd) => {
  delete userToAdd.token;
  let localStorageObj   = JSON.parse(localStorage.getItem(USERKEY));
  let usuariosHistorico = localStorageObj.usuariosHistorico || [];
 
  const userIndex = usuariosHistorico.findIndex(usuario => usuario.login === userToAdd.login);
  if (userIndex > -1){
    usuariosHistorico[userIndex] = userToAdd;
  } else{
    usuariosHistorico.push(userToAdd); 
  } 
  
  localStorageObj.usuariosHistorico = usuariosHistorico;
  localStorage.setItem(USERKEY, JSON.stringify(localStorageObj));
}

const removeUsuarioHistorico = (user) => {
  let obj = JSON.parse(localStorage.getItem(USERKEY));
  let usuariosHistorico = obj.usuariosHistorico || [];
  usuariosHistorico.splice(usuariosHistorico.findIndex(e => e.login == user.login),1);
  obj.usuariosHistorico = usuariosHistorico;
  localStorage.setItem(USERKEY, JSON.stringify(obj));
}

const getTextoTraduzido = (texto) => {
  return texto ? (texto[getIdioma()] || texto['PT'] || texto) : '';
}

const getSessionKey = () => {
  return window.location.host.split('.')[0] + '-clic-framework';
}

const getToken = () => {
  if (temKey()) {
    let obj = JSON.parse(localStorage.getItem(USERKEY));
    return obj.accessToken;
  }
}

const removeUserObj = (_this) => {
  if (temKey()) {
    let obj = JSON.parse(localStorage.getItem(USERKEY));
    delete obj.token;
    localStorage.setItem(USERKEY, JSON.stringify(obj));

    const postMessage = {
      type : "userAction",
      params : { 
        action : "logout"
      }
    };
    _this.window?.ReactNativeWebView?.postMessage(JSON.stringify(postMessage));
    
    _this.$router.go();
  }
  removeAuthorization();
}

const logout = () => {
  let sessao = JSON.parse(localStorage.getItem(getSessionKey()));
  
}

const getFrontendProducao = (subdominio) => {
  return new Promise((resolve, reject) => {
    let obj = {};
    let version = 0;
    if (temKey()) {
      obj = JSON.parse(localStorage.getItem(USERKEY));
      if  (obj.frontend) {
        version = obj.frontendVersion || 0;
      }
    }

    const api = `${process.env.VUE_APP_BACKEND_URL}/api/frontend?subdominio=${subdominio}&situacao=A&version=${version}&teste=1`
    axios.get(api).then(retorno => {
      let newVersion = lodash.get(retorno, 'data.version', 0);
      let dadosFrontend = lodash.get(retorno, 'data.dados', obj.frontend);
      obj.frontend = dadosFrontend;
      obj.frontendVersion = newVersion;
      localStorage.setItem(USERKEY, JSON.stringify(obj));
      resolve(dadosFrontend);

    }).catch((error) => {
      console.log("Não foi possível obter o frontend da API. Carregando frontend local... ", error);
      if (obj.frontend) {
        resolve(obj.frontend);
      } else {
        console.log("Não existe o cache de frontend local.");
        reject();
      }
    });
    
  });
}

const getFrontend = (subdominio) => {
  if (!previaStudio.ativa()) return getFrontendProducao(subdominio);
  return previaStudio.obterFrontend(axios)
    .then((dados) => dados || getFrontendProducao(subdominio));
};

export default {
  getToken,
  getUserObj,
  setUserObj,
  removeUserObj,
  temKey,
  setIdioma,
  getIdioma,
  getTextoTraduzido,
  getUsuariosHistorico,
  addUsuarioHistorico,
  removeUsuarioHistorico,
  getSessionKey,
  getFrontend,
  getLocalData,
}
